import { createSelector } from "@reduxjs/toolkit"
import { type RootState } from "../../store"

export const getContextOptions = createSelector(
  (state: RootState) => state.contextOptions,
  ({ byIds, allIds }) => allIds.map((id) => byIds[id])
)
